import React, { useEffect, useState } from 'react';
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBTable,
} from 'mdb-react-ui-kit';
import zerosModalDialogStyles from './ZerosModalDialog.module.scss';
import TableHeader from '../../../components/table/TableHeader';
import TableBody from '../../../components/table/TableBody';

export default function ZerosModalDialog({show, setShow, cero, doublets, closeAction}: any) { 

    const [hiddeColumns, setHiddeColumns] = useState();
    // const [hiddeColumnsBool, setHiddeColumnsBool] = useState(false);
  
    useEffect(() => {
       setHiddeColumns(window.innerWidth < 1024 ? 'none':'table-cell');
      // setHiddeColumnsBool(hiddeColumns === 'none');
    });

    return (
        show && <MDBModal open={show} tabIndex='-1' style={show?{opacity: 1, display: 'flex'}:{opacity: 0, display: 'none'}}>
            <MDBModalDialog style={{transform:"translate(0, 0vh)", margin: "auto"}} className={zerosModalDialogStyles.modalDialogSize}>
            <MDBModalContent className={zerosModalDialogStyles.modalContentSize}>
                <MDBModalHeader>
                <MDBModalTitle>Listado de Equipos con {cero} Ceros</MDBModalTitle>
                <MDBBtn className='btn-close' color='none' onClick={()=>closeAction()}></MDBBtn>
                </MDBModalHeader>
                <MDBModalBody>
                    <div style={{fontSize:"16px"}}>Actualmente hay {' ' + doublets.length + ' '} equipo(s) con {' ' + cero + ' '} cero(s)</div>
                    { doublets ? <>
                        <div className={zerosModalDialogStyles.modalBodySize}>
                            <MDBTable striped align='middle' style={{maxHeight:"300px", overflow: 'scroll'}}>
                                <TableHeader light>
                                <tr>
                                    <th colSpan={2} className='text-center' style={{zIndex:'99'}}>Listado Parejas</th>
                                    <th colSpan={1} className='text-center'>Puesto</th>
                                    <th colSpan={3} className='text-center'>Partidas</th>
                                    <th colSpan={2} style={{display: hiddeColumns}} className='text-center'>Juegos</th>
                                </tr>
                                <tr>
                                    <th style={{width:'20px', zIndex:'99'}} >Num</th>
                                    <th style={{minWidth:'70px', maxWidth:'130px', zIndex:'99'}}>Pareja</th>
                                    <th style={{minWidth:'70px', maxWidth:'130px'}}>Puesto</th>
                                    <th style={{width:'30px', display: hiddeColumns}} className='text-center'>G</th>
                                    <th style={{width:'30px', display: hiddeColumns}} className='text-center'>P</th>
                                    <th style={{width:'30px'}} className='text-center'>E</th>
                                    <th style={{width:'30px'}} className='text-center'>F</th>
                                    <th style={{width:'30px'}} className='text-center'>C</th>
                                </tr>
                                </TableHeader>
                                <TableBody >
                                    {doublets?.sort((a, b) => {
                                    let result = a.position - b.position;
                                    return result;
                                    }).map((item, index) => {
                                    return (
                                        <tr>
                                            <td style={{zIndex:'99'}} >
                                                {item.id}
                                            </td>
                                            <td style={{minWidth:'70px', maxWidth:'250px', textWrap: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', zIndex:'99'}}>
                                                {item.nameDoublet}
                                            </td>
                                            <td className='text-center'>{item.position ? item.position : 1}</td>
                                            <td style={{color: '#4baf4f', fontWeight: 'bold'}} className='text-center'>{item.earned}</td>
                                            <td style={{color: 'red', fontWeight: 'bold'}} className='text-center'>{item.losses}</td>
                                            <td style={{color: '#3883fe', fontWeight: 'bold'}} className='text-center'>{item.exents}</td>
                                            <td style={{display: hiddeColumns}} className='text-center'>{item.pointsPositive}</td>
                                            <td style={{display: hiddeColumns}} className='text-center'>{item.pointsNegative}</td>
                                        </tr>
                                    )
                                    })}
                                </TableBody>
                            </MDBTable>
                        </div>
                    </>:<></> }
                </MDBModalBody>

                <MDBModalFooter style={{justifyContent: 'space-evenly'}}>
                <MDBBtn color='secondary' onClick={()=>{
                    closeAction()
                }}>
                    Cerrar
                </MDBBtn>
                </MDBModalFooter>
            </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    );
}